module.exports = __webpack_public_path__ + "static/es-c86f42964d0a67559ede8d6612546175.png";